// extracted by mini-css-extract-plugin
module.exports = {"rating":"nk","numberOfStars":"ok"};